import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import { AuthProvider } from "./lib/auth";
import { ImagesProvider } from "./lib/images";
import { TextsProvider } from "./lib/texts";
import MatrixRain from "./components/MatrixRain";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import XegaVip from "./pages/XegaVip";
import MerchFinder from "./pages/MerchFinder";
import ETracker from "./pages/ETracker";
import Sentinel from "./pages/Sentinel";
import Escoltas from "./pages/Escoltas";
import SeguridadPrivada from "./pages/SeguridadPrivada";
import About from "./pages/About";
import MonitoringCenter from "./pages/MonitoringCenter";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Leads from "./pages/admin/Leads";
import ImagesEditor from "./pages/admin/ImagesEditor";
import TextsEditor from "./pages/admin/TextsEditor";
import ContentEditor from "./pages/admin/ContentEditor";
import Users from "./pages/admin/Users";
import ActivityLog from "./pages/admin/ActivityLog";
import Reports from "./pages/admin/Reports";

function App() {
  useEffect(() => {
    document.title = "Xega | Alta Tecnología en Seguridad";
  }, []);
  return (
    <div className="App">
      <MatrixRain />
      <I18nProvider>
        <AuthProvider>
          <ImagesProvider>
          <TextsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/quienes-somos" element={<About />} />
              <Route path="/servicios" element={<Services />} />
              <Route path="/servicios/xega-vip" element={<XegaVip />} />
              <Route path="/servicios/merch-finder" element={<MerchFinder />} />
              <Route path="/servicios/e-tracker" element={<ETracker />} />
              <Route path="/servicios/sentinel" element={<Sentinel />} />
              <Route path="/servicios/escoltas" element={<Escoltas />} />
              <Route path="/servicios/seguridad-privada" element={<SeguridadPrivada />} />
              <Route path="/servicios/:slug" element={<ServiceDetail />} />
              <Route path="/centro-monitoreo" element={<MonitoringCenter />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="leads" element={<Leads />} />
                <Route path="images" element={<ImagesEditor />} />
                <Route path="texts" element={<TextsEditor />} />
                <Route path="content" element={<ContentEditor />} />
                <Route path="users" element={<Users />} />
                <Route path="activity" element={<ActivityLog />} />
                <Route path="reports" element={<Reports />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#0B0F17", border: "1px solid rgba(0,240,255,0.3)", color: "#fff" } }} />
          </TextsProvider>
          </ImagesProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
